import { render, staticRenderFns } from "./confirmDeleteTemplate.vue?vue&type=template&id=31d386be&scoped=true"
import script from "./confirmDeleteTemplate.vue?vue&type=script&lang=js"
export * from "./confirmDeleteTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d386be",
  null
  
)

export default component.exports